// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__bcbcv","loading":"Pagination_loading__F1NE6"};